import React, { useEffect } from "react";
import { Dashboard } from "../../_metronic/_partials";
import { useSubheader } from "../../_metronic/layout";
import { useIntl } from "react-intl";

export function DashboardPage() {
  const intl = useIntl();
  const { setTitle } = useSubheader();
  const title = intl.formatMessage({ id: "DASHBOARD" });
  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);
  return <Dashboard />;
}
